import { Skeleton } from "../ui/skeleton";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "../ui/table";

const TableSkeleton = () => {
	return (
		<Table className="my-[16px]">
			<TableHeader>
				<TableRow>
					<TableHead>
						<Skeleton className="h-4 w-[100px]" />
					</TableHead>
					<TableHead>
						<Skeleton className="h-4 w-[200px]" />
					</TableHead>
					<TableHead>
						<Skeleton className="h-4 w-[150px]" />
					</TableHead>
					<TableHead>
						<Skeleton className="h-4 w-[150px]" />
					</TableHead>
				</TableRow>
			</TableHeader>
			<TableBody>
				{[...Array(5)].map((_, index) => (
					<TableRow key={index}>
						<TableCell>
							<Skeleton className="h-4 w-[100px]" />
						</TableCell>
						<TableCell>
							<Skeleton className="h-4 w-[200px]" />
						</TableCell>
						<TableCell>
							<Skeleton className="h-4 w-[150px]" />
						</TableCell>
						<TableCell>
							<Skeleton className="h-4 w-[150px]" />
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	);
};

export default TableSkeleton;
